

/* eslint-disable no-undef */
/* global $, moment, Datepicker, DateRangePicker */
import $ from 'jquery';
import moment from 'moment';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
// Rendi jQuery e moment globali per plugin legacy
window.$ = $;
window.jQuery = $;
window.moment = moment;

// Inizializzazione: quando DOM pronto
$(function () {
  $('#my-datepicker').daterangepicker({
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
    locale: {
      format: 'YYYY-MM-DD'
    }
  });
});
